module.exports = __webpack_public_path__ + "img/TechGatherFarm3_ua.e04f2010.webp";